import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Swal from 'sweetalert2'; // Import SweetAlert
import Select from "react-select";
import RequestServies from "../../../services/RequestServies";
import ProductServices from "../../../services/ProductServices";


const Fabrication = ({ onSuccess }) => {
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [isModelOpen, setIsModelOpen] = useState();

  const user = JSON.parse(localStorage.getItem("userDetails"));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || "";

  const [stores, setStores] = useState(availableStores);
  const [selectedStore, setSelectedStore] = useState(defaultStore);

  const [requisition, setRequisiton] = useState('');
  const [selectedRequisition, setSelectedRequisiton] = useState('');
  const [run, setRun] = useState(0);
  const [loading, setLoading] = useState(false);

  const [items, setItems] = useState([
    { name: "", inventoryId: "",description:"", currentQty: 0, auth: 0, quantity: 0, error: "" },
  ]);
  const [partOptions, setPartOptions] = useState([]);
  const [item, setItem] = useState();

  const handleAddItem = (e) => {
    e.preventDefault();
    const lastItem = items[items.length - 1];
    
    // Check for required fields
    if (!lastItem || !lastItem.inventoryId || !lastItem.name || lastItem.quantity <= 0) {
        Swal.fire({
            icon: 'warning',
            title: 'Incomplete Item',
            text: 'Please fill in all fields (Inventory, Name, and Required Qty) before adding a new item.',
            confirmButtonText: 'OK'
        });
        return; // Exit if the last item doesn't have all required fields filled
    }
    
    setItems([
      ...items,
      { name: "", inventoryId: "",description:"", currentQty: 0, auth: 0, quantity: 0, error: "" },
    ]);
  };

  const handleItemChange = (index, field, value) => {
    console.log(value);
    const newItems = [...items];
    newItems[index][field] = value;

    if (field === "quantity") {
      if (value > newItems[index].currentQty) {
        newItems[index].error = `Required Qty cannot be greater than current Qty`;
      } else if (value <= 0) {
        newItems[index].error = `Required Qty cannot be 0 or negative`;
      } else {
        newItems[index].error = "";
      }
    }
    console.log(newItems);
    setItems(newItems);
  };

  const handlePartSelect = (index, selectedOption) => {
    const isDuplicate = items.some(item => item.inventoryId === selectedOption.value);

    if (isDuplicate) {
        Swal.fire({
            icon: 'error',
            title: 'Duplicate Item',
            text: 'This item has already been added to the requisition.',
            confirmButtonText: 'OK'
        });
        return; // Exit the function if a duplicate is found
    }
    console.log(index, selectedOption);
    handleItemChange(index, "inventoryId", selectedOption.value);
    handleItemChange(index, "name", selectedOption.label);
    handleItemChange(index, "currentQty", selectedOption.currentStock);
    handleItemChange(index, "auth", selectedOption.auth);
    handleItemChange(index, "description", selectedOption.description); // Set description
    handleItemChange(
      index,
      "eligible",
      selectedOption.auth - selectedOption.currentStock
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let isValid = true;
    let errorMessage = "";

    items.forEach((item, index) => {
      if (item.quantity > item.currentQty) {
        isValid = false;
        errorMessage = `Item ${index + 1}: Required Qty cannot be greater than eligible Qty`;
      } else if (item.quantity <= 0) {
        isValid = false;
        errorMessage = `Item ${index + 1}: Required Qty cannot be 0 or negative`;
      }
    });

    if (!isValid) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: errorMessage,
        confirmButtonText: 'OK'
      });
      return;
    }

    const requestData = { storeId: selectedStore, sentItems:items };

    RequestServies.submitFabrication(requestData)
      .then((response) => {
        console.log('Submission successful:', response);

        // Show Swal success message
        Swal.fire({
          icon: 'success',
          title: 'Submission Successful',
          text: 'Your requisition has been submitted successfully!',
          confirmButtonText: 'OK'
        });

        setItems([
          { name: "", inventoryId: "",description:"", currentQty: 0, auth: 0, quantity: 0, error: "" },
        ]);  // Clear the items
        setRun(run + 1);  // Trigger any state update
      })
      .catch((error) => {
        console.log('Error during submission:', error);

        // Show Swal error message
        Swal.fire({
          icon: 'error',
          title: 'Submission Failed',
          text: 'An error occurred while submitting the requisition.',
          confirmButtonText: 'Try Again'
        });

        // Handle error feedback here (additional error handling if needed)
      });

  };



  const handleRemoveItem = (e, index) => {
    e.preventDefault();
    const newItems = [...items];
    newItems.splice(index, 1);
    setItems(newItems);
  };

  // const handleAddItemSubmit = (event) => {
  //   event.preventDefault(); // Prevent form submission
  //   // Call your API to add the item
  //   const itemToAdd = items[items.length - 1]; // Assuming you're adding the last item
  //   itemToAdd.requisitionNo =  selectedRequisition;

  //   console.log(itemToAdd)
  //   RequestServies.createItem(itemToAdd) // Replace with your actual API call
  //     .then(response => {
  //       console.log('Item added successfully', response);
  //       onSuccess(); // Call the success callback if needed
  //     })
  //     .catch(error => {
  //       console.error('Error adding item', error);
  //     });
  // };

  useEffect(() => {
    if (selectedStore) {
      RequestServies.getRequest(selectedStore)
        .then((res) => {
          setRequisiton(res?.data?.data);
          setSelectedRequisiton(res?.data?.data[0]._id);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [selectedStore, run]);

  useEffect(() => {
    const fetchInventory = async () => {
        setLoading(true); // Set loading to true before fetching
        setPartOptions({})
        try {
            const res = await ProductServices.getInventory(selectedStore);
            const options = res.data.data.map((part) => ({
                value: part._id,
                label: part.masterItem.partNo,
                auth: part.qtyAuth,
                description: part.masterItem.description,
                currentStock: part.currentStock,
            }));
            setPartOptions(options);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false); // Set loading to false after fetching
        }
    };

    if (selectedStore) {
        fetchInventory();
        setItems([
          { name: "", inventoryId: "",description:"", currentQty: 0, auth: 0, quantity: 0, error: "" },
        ])
    }
}, [selectedStore]);


  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
    setSelectedRequisiton()
  };

  const handleRequsitionChange = (e) => {
    setSelectedRequisiton(e.target.value);
  };
  const handleRequisitionForm = (item) => {
    setIsModelOpen(true);
  };
  return (
    <>
     
      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fas fa-filter me-2"></i>Filter
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                  onClick={() => setOpen(!open)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-12 col-xxl-12">
                      <label>Select Store</label>
                      <select
                        className="form-select mb-xl-0 mb-3"
                        value={selectedStore}
                        onChange={handleStoreChange}
                      >
                        {stores.map((store) => (
                          <option key={store._id} value={store._id}>
                            {store.name}
                          </option>
                        ))}
                      </select>
                    </div>
                   

                   

                  </div>
                </div>
              </div>
            </Collapse>
          </div>
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fa fa-plus me-2" aria-hidden="true"></i>Add
                Fabrication Item
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                  onClick={() => setOpen2(!open2)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <div
                      id="content_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <form>
                        {items.map((item, index) => (
                          <div key={index} className="row">
                            <div className="form-group mb-2 col-md-2">
                              <label>Select Inventory</label>
                              <Select
                                options={loading ? [] : partOptions} // Show empty options if loading
                                onChange={(selectedOption) => handlePartSelect(index, selectedOption)}
                                placeholder={loading ? "Loading..." : "Part No"}
                                menuPortalTarget={document.body}
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minWidth:90, // increase width (adjust as needed)
                                    height:14, // increase height (adjust as needed)
                                    fontSize: '12px', // change font size (optional)
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    height: '100%', // ensures the value container aligns with the control height
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    height: 'auto', // allows the input to grow with the control's height
                                  }),
                                }}
                              />

                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>Description</label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                name="description"
                                value={item.description}
                                placeholder="Description"
                              />
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>Auth Qty</label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                name="auth"
                                value={item.auth}
                                placeholder="Auth"
                              />
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>Current Qty</label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                name="currentQty"
                                value={(item.currentQty)}
                                placeholder="Current Qty"
                              />
                            </div>
                         
                            <div className="form-group mb-2 col-md-2">
                              <label>Required Qty</label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="quantity"
                                value={item.quantity}
                                onChange={(event) =>
                                  handleItemChange(
                                    index,
                                    "quantity",
                                    event.target.value
                                  )
                                }
                                placeholder="Required Qty"
                              />
                              <p className="text-danger">{item.error}</p>
                            </div>
                            <div className="form-group mb-1 col-md-1">

                              <button className="btn btn-danger btn-xs sharp mt-1"
                                onClick={(e) => handleRemoveItem(e, index)}
                              >
                                <i className="fa fa-trash"></i>
                              </button>

                            </div>
                          </div>
                        ))}
                        <div className="row">
                          <div className="form-group col-md-2">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={(e) => handleAddItem(e)}
                            >
                              Add
                            </button>
                          </div>

                          <div className="form-group col-md-2">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={handleSubmit}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3"></div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default Fabrication;
